import { useQuery } from "@tanstack/react-query";
import apiClient from "services/ApiClient";
import { MeetingId } from "../models";
import { AvailabilityResponse } from "../Components/Form/ScheduleMeetingForm/FindATime/types";

function buildQueryString(params: {
  date: string;
  timezone?: string;
  additionalMeetingIds?: string[];
}): string {
  const searchParams = new URLSearchParams();
  searchParams.append("date", params.date);
  if (params.timezone) searchParams.append("timezone", params.timezone);
  if (params.additionalMeetingIds) {
    params.additionalMeetingIds.forEach((id) => searchParams.append("additional_meeting_ids[]", id));
  }
  return searchParams.toString();
}

export default function useAvailabilityQuery(
  meetingId: MeetingId,
  params: { date: string; timezone?: string; additionalMeetingIds?: string[] },
  options: { enabled?: boolean } = {},
) {
  const queryString = buildQueryString(params);

  return useQuery<AvailabilityResponse>({
    queryKey: [meetingId, "availability", queryString],
    queryFn: async () => apiClient.get(`/api/meetings/${meetingId}/availability?${queryString}`),
    staleTime: 1000 * 60 * 3,
    enabled: !!meetingId && !!params.date && (options.enabled ?? true),
  });
}
